/** @prettier */
import {barGraphBasicSetting} from './barGraphBasicSetting';
import {TFunction} from 'i18next';
import {GraphDataRange} from '../../../../Type/TypeDef';
import {graph} from '../../../../define';

/**
 * 消費電力グラフ 個別表示 Chiller の表示設定
 * @param props props
 * @returns 表示設定
 */
export const aggregationChillerBarGraphSetting = (props: {
  xLabel: string[]; //X軸のラベル
  dateRange: GraphDataRange; //データ取得範囲
  csvFileNameDate: string; //CSVファイルの名前（日付部分）
  csvFileNameTarget: string; //CSVファイルの名前（サイトの名前 + グラフの対象の名前）
  barGraphPowerConsumptionCool: ApexAxisChartSeries['0']['data']; //暖房グラフデータ
  barGraphPowerConsumptionHot: ApexAxisChartSeries['0']['data']; //冷房グラフデータ
  comparisonBarGraphPowerConsumptionCool: ApexAxisChartSeries['0']['data']; //暖房グラフデータ（別の日）
  comparisonBarGraphPowerConsumptionHot: ApexAxisChartSeries['0']['data']; //冷房グラフデータ（別の日）
  trans: TFunction; //翻訳関数
}) => {
  /** Apex Chartsのseries設定
   * - name グラフの凡例
   * - type グラフの種類
   * - group グラフデータのグループ
   * - data グラフデータ
   */
  let seriesProps: ApexAxisChartSeries = [];

  //COMPARISONボタンの押下毎に、表示するグラフと凡例の数を切り替える。
  if (
    props.comparisonBarGraphPowerConsumptionCool.length > 0 ||
    props.comparisonBarGraphPowerConsumptionHot.length > 0
  ) {
    //COMPARISONボタンの押下回数が奇数の場合、グラフと凡例を2つずつ表示する。
    //奇数:comparison**のデータをBarChartGraphから受け取る。(データ長≠0)
    //偶数:comparison**のデータをBarChartGraphから受け取らない。(データ長＝0)
    seriesProps = [
      {
        name: `${props.trans(
          'aggregationChillerBarGraphSetting.graphItem.comparisonBarGraphPowerConsumptionCool'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphPowerConsumptionCool,
      },
      {
        name: `${props.trans(
          'aggregationChillerBarGraphSetting.graphItem.comparisonBarGraphPowerConsumptionHot'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphPowerConsumptionHot,
      },
      {
        name: `${props.trans(
          'aggregationChillerBarGraphSetting.graphItem.barGraphPowerConsumptionCool'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphPowerConsumptionCool,
      },
      {
        name: `${props.trans(
          'aggregationChillerBarGraphSetting.graphItem.barGraphPowerConsumptionHot'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphPowerConsumptionHot,
      },
    ];
  } else {
    seriesProps = [
      {
        name: `${props.trans(
          'aggregationChillerBarGraphSetting.graphItem.barGraphPowerConsumptionCool'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphPowerConsumptionCool,
      },
      {
        name: `${props.trans(
          'aggregationChillerBarGraphSetting.graphItem.barGraphPowerConsumptionHot'
        )}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphPowerConsumptionHot,
      },
    ];
  }

  /** Apex Chartsのoptions設定
   * - xLabel X軸に表示するラベル
   * - dateRange データ取得範囲
   * - csvFileNameDate csvファイル名に表示する日付
   * - csvFileNameTarget csvファイル名に表示するサイト名 + ユニット名
   * - trans 翻訳関数
   */
  let optionProps = barGraphBasicSetting({
    xLabel: props.xLabel,
    dateRange: props.dateRange,
    csvFileNameDate: props.csvFileNameDate,
    csvFileNameTarget: props.csvFileNameTarget,
    trans: props.trans,
  });

  //グラフ配色一覧
  const graphColor = [
    graph.GRAPH_COLOR_CYAN, //Cyan 0 冷房データ
    graph.GRAPH_COLOR_GOLD, //Gold 1 暖房データ
    graph.GRAPH_COLOR_LIGHT_COOL, //Light Cool 2 冷房データ（比較）
    graph.GRAPH_COLOR_LIGHT_HEAT, //Light Heat 3 暖房データ（比較）
  ];
  //COMPARISONボタンの押下毎に、グラフの配色を切り替える。
  if (
    props.comparisonBarGraphPowerConsumptionCool.length > 0 ||
    props.comparisonBarGraphPowerConsumptionHot.length > 0
  ) {
    //奇数:comparison**のデータをBarChartGraphから受け取る。(データ長≠0)
    //偶数:comparison**のデータをBarChartGraphから受け取らない。(データ長＝0)
    optionProps.colors = [
      graphColor[2],
      graphColor[3],
      graphColor[0],
      graphColor[1],
    ];
  } else {
    optionProps.colors = [graphColor[0], graphColor[1]];
  }

  //データ取得範囲が1日の場合、ラベルの間隔が狭く見づらいためx軸のラベルを傾けるオプションを追加する
  if (
    props.xLabel.length === 24 &&
    optionProps.xaxis &&
    optionProps.xaxis.labels
  ) {
    optionProps.xaxis.labels.rotate = -45;
    optionProps.xaxis.labels.rotateAlways = true;
  }

  return {
    series: seriesProps,
    options: optionProps,
  };
};
